/**
 * Consistent role color configuration used across the app
 * Used in users management page and sidebar footer
 * Admin roles use darker shades to differentiate from team roles
 */

import type { UserRole } from '@/types/database';

export const ROLE_CONFIG: Record<UserRole, { label: string; badgeClass: string }> = {
  SYSTEM_ADMIN: {
    label: 'System Admin',
    badgeClass: 'bg-slate-700 text-white hover:bg-slate-800',
  },
  PLATFORM_TEAM: {
    label: 'Platform Team',
    badgeClass: 'bg-blue-500 text-white hover:bg-blue-600',
  },
  PLATFORM_ADMIN: {
    label: 'Platform Admin',
    badgeClass: 'bg-blue-700 text-white hover:bg-blue-800',
  },
  IT_TEAM: {
    label: 'IT Team',
    badgeClass: 'bg-orange-500 text-white hover:bg-orange-600',
  },
  IT_ADMIN: {
    label: 'IT Admin',
    badgeClass: 'bg-orange-700 text-white hover:bg-orange-800',
  },
  DATA_TEAM: {
    label: 'Data Team',
    badgeClass: 'bg-green-500 text-white hover:bg-green-600',
  },
  DATA_ADMIN: {
    label: 'Data Admin',
    badgeClass: 'bg-green-700 text-white hover:bg-green-800',
  },
};

export const ROLE_LABELS: Record<UserRole, string> = {
  SYSTEM_ADMIN: ROLE_CONFIG.SYSTEM_ADMIN.label,
  PLATFORM_TEAM: ROLE_CONFIG.PLATFORM_TEAM.label,
  PLATFORM_ADMIN: ROLE_CONFIG.PLATFORM_ADMIN.label,
  IT_TEAM: ROLE_CONFIG.IT_TEAM.label,
  IT_ADMIN: ROLE_CONFIG.IT_ADMIN.label,
  DATA_TEAM: ROLE_CONFIG.DATA_TEAM.label,
  DATA_ADMIN: ROLE_CONFIG.DATA_ADMIN.label,
};

export const getRoleConfig = (role: string): (typeof ROLE_CONFIG)[UserRole] | null => {
  return ROLE_CONFIG[role as UserRole] || null;
};
